import { ResponseModel } from '@r-and-a-shared-ui/utils';
import { ActionHandlerParams } from '../types';
import { z } from 'zod';
import { userMutationHandler } from '../config/form-action-mutation-handlers';
import {
  pp_preExecMutationCheck,
  pp_preExecMutationCheckWithFormValidation,
} from './pp-config-helpers/pp-config-mutation-helpers';

export const pp_genericMutationHandlerWithFormValidation = async <
  InputSchema extends z.ZodSchema,
>(
  params: ActionHandlerParams,
  inputSchema: InputSchema,
  defaultValuesObj?: unknown,
): Promise<ResponseModel> => {
  const requestData = await pp_preExecMutationCheckWithFormValidation(
    params,
    inputSchema,
    defaultValuesObj,
  );
  return await userMutationHandler(requestData, params);
};

export const pp_genericMutationHandler = async <
  InputSchema extends z.ZodSchema,
>(
  params: ActionHandlerParams,
  inputSchema: InputSchema,
  defaultValuesObj?: unknown,
  ignoreError = false,
): Promise<ResponseModel> => {
  const requestData = await pp_preExecMutationCheck(
    params,
    inputSchema,
    defaultValuesObj,
  );
  return await userMutationHandler(requestData, params, ignoreError);
};
